import { InjectionToken, makeStateKey, StateKey, TransferState } from '@angular/core';
import { SEO_CONFIG_FALLBACK, type SeoConfig } from '../../../server/seo-config.contract';

/**
 * N2: канал доставки SEO-конфига в Angular. На SSR `initSeoConfig` фетчит `/seo/config`
 * и кладёт результат в TransferState под этим ключом; в браузере значение приезжает с
 * гидратацией. `SEO_CONFIG` отдаёт его синхронно (фабрика читает TransferState), поэтому
 * `CanonicalUrlBuilder`/`SeoMetaService` работают одинаково на сервере и в браузере.
 * Пусто (нет SSR-фетча / showcase) → безопасный `SEO_CONFIG_FALLBACK`.
 */
export const SEO_CONFIG_STATE_KEY: StateKey<SeoConfig> = makeStateKey<SeoConfig>('seoConfig');

export const SEO_CONFIG = new InjectionToken<SeoConfig>('SEO_CONFIG');

export function seoConfigFactory(transferState: TransferState): SeoConfig {
  return transferState.get(SEO_CONFIG_STATE_KEY, SEO_CONFIG_FALLBACK);
}
